<template>
	<div>
		<div @click="godetail()" class="item padding-tb-sm padding-lr-sm margin-bottom-sm flex flex-direction justify-between" :style="[{ width: width+'px',height:height+'px'}]">
			<p class="text-cut text-left" :style="[{ fontSize:size+'px'}]">{{data.userInfo.title}}</p>
			
			<div class="flex align-end justify-between" >
				<div class="flex align-center">
					<img class="block-63 round margin-right-19" :src="data.user&&data.user.avatar" mode=""></img>
					<div class="flex flex-direction justify-between margin-left-xs">
						<p class="text-333 text-sm text-left">{{data.user&&data.user.nick_name}}</p>
						<div class="flex align-center">
							<img class="block-13 margin-right-xxs" :src="data.user&&data.user.sex == 1?'https://manage.ciiply.com/web/static/my/sex-nan.png':data.user&&data.user.sex == 2?'https://manage.ciiply.com/web/static/my/sex-nv.png':''" mode=""></img>
							<p class="text-666 text-sm text-xxs" v-if='data.user&&data.user.nation'>{{data.user.nation}}族</p>
							<p class="text-666 margin-lr-xxs text-sm" v-if='data.user&&data.user.nation'>|</p>
							<p class="text-666 text-sm text-xxs" v-if='data.userInfo&&data.userInfo.experience'>{{data.userInfo.experience}}年经验</p>
							<p class="text-666 margin-lr-xxs text-sm" v-if='data.userInfo&&data.userInfo.experience'>|</p>
							<p class="text-666 text-sm text-xxs">{{data.userInfo&&data.userInfo.type | filterType}}</p>
						</div>
					</div>
				</div>
				<div class="call-btn">联系TA</div>
			</div>
			<div class="flex justify-between align-start">
				<div class="flex justify-between align-center">
					
					<p class="text-999 text-xs" v-if="data.userInfo.wages != 0">期望月薪</p>
					<p class="text-prices text-bold margin-left-xs" :class="data.userInfo.wages == 0?'':'text-price'" :style="[{ fontSize:size+'px'}]">{{data.userInfo.wages == 0 ? '面议' : data.userInfo.wages}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  props: {
	    width: {
	      type: [String,Number],
	      default:387
	    },
	    height:{
	    	type: [String,Number],
	    	default:168
	    },
		size:{//标题字体
			type: [String,Number],
			default:18
		},
		data:{
			type: Object,
			default:{}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(){
	    	this.$router.push({
	    		name:'resumeDetail',
	    		query: {
	    			id:this.data.id
	    		}
	    	})
	    }
	  },
	  filters:{
	  	filterType(val) {
	  	  switch (val) {
	  		case 0:
	  		  	return '个人';
	  	  	case 1:
	  	  		return '班组';
	  	  	case 2:
	  	  		return '施工队';
	  	  	case 3:
	  	  		return '突击队';
	  	  
	  	  	default:
	  	  		return '';
	  	  }
	  	}
	  }
	};
</script>

<style scoped lang="less">
	.item{
		// width: 387px;
		// height: 168px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		position: relative;
		.block-63{
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}
		.block-13{
			width: 13px;
			height: 13px;
		}
		.add{
			width: 16px;
			height: 19px;
		}
		.margin-left-8{
			margin-left: 8px;
		}
		.margin-lr-xxs{
			margin-left: 5px;
			margin-right: 5px;
		}
		.margin-right-xxs{
			margin-right: 5px;
		}
		.sticky{
			position: absolute;
			top: 0;
			right: 0;
			width: 45px;
			height: 24px;
			font-size: 13px;
			line-height: 24px;
			background: rgba(11, 131, 124, 0.1);
			border-radius: 0px 20px 0px 0px;
			color: #0B837C;
		}
		.tip-item{
			font-size: 13px;
			padding: 5px 10px;
			border-radius: 12px;
			background: #F1F1F1;
			margin-right: 9px;
		}
		.call-btn{
			width: 115px;
			height: 40px;
			line-height: 40px;
			background: #0B837C;
			color: #fff;
			border-radius: 25px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/seen/resume-list.vue